import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";

// shared profileView branch: wraps children in a Card everywhere except
// profile view, where the caller's own layout already provides the card
export function SectionCardWrapper(props) {
  const { Card = CardSecondary, cardProps, children, plainProps, profileView } = props;

  if (profileView) {
    return <div {...plainProps}>{children}</div>;
  }

  return <Card {...cardProps}>{children}</Card>;
}
